<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<p class="documentation-title">LfBreadcrumbs</p>

<p class="documentation-text code-container">
  <code>
    <span class="code-html-tagname">&lt;lf-breadcrumbs&gt;&lt;/lf-breadcrumbs&gt;</span>
  </code>
</p>
<p class="documentation-text code-container">
  <code>
    <span class="code-html-tagname">const </span>
    <span class="code-html-attribute-name">breadcrumbsElement</span>
    <span>=</span>
    <span>document.querySelector('lf-breadcrumbs');</span>
    <p>breadcrumbsElement.breadcrumbs = breadcrumbsObject;</p>
  </code>
</p>
<app-card>
  <lf-breadcrumbs
    #breadcrumbs
    [breadcrumbs]="elementBreadcrumbOptions"
    (breadcrumbSelected)="onElementBreadcrumbSelected($event)"
  ></lf-breadcrumbs>
</app-card>
<p class="documentation-text">onElementBreadcrumbSelected output:</p>
<textarea disabled cols="80" rows="10">{{ selectedElementBreadcrumb }}</textarea>

<p class="documentation-header">Overview</p>
<p class="documentation-text">
  Custom Element that displays a list of breadcrumbs, allowing the user to select the parent, or one from the dropdown.
</p>

<p class="documentation-header">HTML Element</p>
<table>
  <tr>
    <th>Attribute</th>
    <th>Value</th>
    <th>Description</th>
  </tr>
  <tr>
    <td>breadcrumbs</td>
    <td>LfBreadcrumb[]</td>
    <td>List of breadcrumbs to display</td>
  </tr>
</table>
<br />
<table>
  <tr>
    <th>Event</th>
    <th>Value</th>
    <th>Description</th>
  </tr>
  <tr>
    <td>breadcrumbClicked</td>
    <td>() => event: CustomEvent&lt;&#123; selected: LfBreadcrumb; breadcrumbs: LfBreadcrumb[]; &#125;&gt;</td>
    <td>
      Event emitted when a breadcrumb is clicked, including the selected breadcrumb as well as the updated breadcrumbs
      after that breadcrumb is selected.
    </td>
  </tr>
  <tr>
    <td>**[DEPRECATED]** breadcrumbSelected</td>
    <td>() => event: CustomEvent&lt;LfBreadcrumb&gt;</td>
    <td>
      This event is deprecated and will be removed in the next major release. It is replaced by breadcrumbClicked.
    </td>
  </tr>
</table>

<p class="documentation-sub-header">LfBreadcrumb Interface</p>
<ul>
  <li>id : string</li>
  <li>name : string</li>
</ul>
